import { render } from "./ProductPricing.vue?vue&type=template&id=7131b84d&scoped=true"
import script from "./ProductPricing.vue?vue&type=script&lang=js"
export * from "./ProductPricing.vue?vue&type=script&lang=js"

import "./ProductPricing.vue?vue&type=style&index=0&id=7131b84d&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7131b84d"]])

export default __exports__